import { Flex, Text } from '@chakra-ui/react';
import React from 'react';
import { Link } from '@chakra-ui/react';

function Footer() {
  return (
    <Flex padding={6} h='20' alignItems='center' justifyContent='center'>
      <Text textAlign='center'>
        made with ❤️ by{' '}
        <Link
          color='brand.secondary'
          href='https://github.com/zidanomar'
          isExternal
        >
          Zidan Omar Hamid
        </Link>
      </Text>
    </Flex>
  );
}

export default Footer;
